@if (createdCount == 0 || allAttributeData?.length == 0 ) { @if (notificationLoading || allAttributeData?.length == 0) {
<div class="mb-2 ownership-container">
  <div class="ph-item width-100per loader-body-item" style="padding: 0px; border: 0px; margin: 0px">
    <div class="ph-col-12" style="padding: 0px !important">
      <div class="ph-row">
        <div class="ph-col-4"></div>
        <div class="ph-col-6 empty"></div>
        <div class="ph-col-2"></div>
      </div>
    </div>
  </div>
</div>
} } @else { @if(createdCount_link_count>0 || createdCount_non_link_count>0){
<div class="ownership-container" style="background: #d0deff; margin-bottom: 2em">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        [expanded]="true"
        class="parametersPanel"
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        style="
          border-bottom-right-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
          box-shadow: none;
        "
        [ngClass]="createdCount == 0 ? 'setEmptyPanelDefault' : ''"
      >
        <mat-expansion-panel-header style="height: 39px !important; background-color: #d0deff; color: #002c6a">
          <mat-panel-title>
            <div class="ownership__header-section">
              <p (click)="$event.stopPropagation()">
                <img src="../../../../../../assets/images/setup-icon.svg" />
                Items to set up
                <span> ({{ itemsToSetUpList | itemSetupCount : value_change }}) </span>
              </p>
              <button
                class="add-ownership-button bg-[#FFFFFF] text-[#18191C] border-none justify-between center"
                mat-button
                [matMenuTriggerFor]="menuItem"
                (click)="$event.stopPropagation()"
              >
                <span style="display: flex; align-items: center; font-weight: 600; gap: 10px; min-width: 120px">
                  <span>{{ selectedCategory }} {{ selectedCategory === 'Links' ? '' : 'Items' }}</span>
                  <span class="material-icons text-[#25508E]" style="position: absolute; right: 0; top: 50%; transform: translateY(-50%)">
                    keyboard_arrow_down
                  </span>
                </span>
              </button>
              <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                <button mat-menu-item class="popup-menu-item custom-menu-bnt-upload" (click)="filterItems('All')">All Items</button>
                <button mat-menu-item class="popup-menu-item custom-menu-bnt-upload" (click)="filterItems('Report')">Report Items</button>
                <button mat-menu-item class="popup-menu-item custom-menu-bnt-upload" (click)="filterItems('Links')">Links</button>
              </mat-menu>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <br />
        <div class="w-full h-1 bg-[#D0DEFF] rounded-[20px] flex items-center absolute left-0" style="background: white !important">
          <span class="h-full bg-[#002C6A] rounded-[20px]" [style.width.%]="CompletionPercentage"> </span>
        </div>
        <br />
        @if (itemsToSetUpList.length > 0) {
        <div>
          <div
            style="margin-bottom: 48px; margin: 0 -24px; background-color: #d0deff"
            [class]="itemsToSetUpList.length > 4 ? 'overflow-y-auto max-h-[250px] h-fit' : 'overflow-y-auto max-h-[250px] h-fit'"
          >
            @for (items of itemsToSetUpList; track items; let i = $index) { @if (items?.status == 'created') {
            <div
              [class]="!!itemsToUpDate() && itemsToUpDate()?.id === items?.id ? 'files-list bg-[#EFFFF7] relative overflow-hidden' : 'files-list'"
              (click)="$event.stopPropagation(); callAction(items)"
            >
              @if (!!itemsToUpDate() && itemsToUpDate()?.id === items?.id) {
              <img src="/assets/gif/confetti-3.gif" alt="" class="w-[100%] absolute left-0" />
              }
              <div class="download-container">
                <div style="display: flex; margin-left: 6px; max-width: 55%">
                  <span style="margin-top: 12px !important">
                    <ngx-avatars
                      class="custom-nx-avatar"
                      size="24"
                      [src]="currentUser?.data?.profile_image_url"
                      name="{{
                        currentUser?.data?.name ??
                          (currentUser?.data?.first_name ?? currentUser?.data?.first_middle_name) + '  ' + currentUser?.data?.last_name
                      }}"
                      [round]="false"
                      initialsSize="2"
                      cornerRadius="100"
                    ></ngx-avatars>
                  </span>
                  @if (items?.type?.toLowerCase() == 'financial_atributes' || items?.type?.toLowerCase() == 'financial_attributes' ) {
                  <p
                    style="padding-left: 6px"
                    class="text-truncate cursor-pointer text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                    [matTooltip]="items | itemSetupName : allAttributeData : linkedTemplateData"
                  >
                    {{ items | itemSetupName : allAttributeData : linkedTemplateData }}
                  </p>
                  } @else if(items?.type?.toLowerCase() == 'insurance_attributes') {
                  <p
                    style="padding-left: 6px"
                    class="text-truncate cursor-pointer text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                    [matTooltip]="items | itemSetupName : insuranceAttributeData : linkedTemplateData"
                  >
                    {{ items | itemSetupName : insuranceAttributeData : linkedTemplateData }}
                  </p>
                  } @else if(items?.type?.toLowerCase() == 'share' && nonVaultFormsOrigins.includes(data.origin)) {
                  <p
                    style="padding-left: 6px"
                    class="text-truncate cursor-pointer text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                    [matTooltip]="'Manage permission settings'"
                  >
                    Manage permission settings
                  </p>
                  } @else {
                  <p
                    style="padding-left: 6px"
                    class="text-truncate cursor-pointer text-sm font-bold text-[#18191C] m-0 leading-[48px]"
                    [matTooltip]="items | itemSetupName : rolePlayersJsonData : linkedTemplateData"
                  >
                    {{ items | itemSetupName : rolePlayersJsonData : linkedTemplateData }}
                  </p>
                  }
                </div>
                <div class="setup-action-button">
                  @if(!hideManageButton){
                  <!-- <div
                    (click)="$event.stopPropagation(); removeSuggestion(items)"
                    class="cursor-pointer bg-[#EBF0FA] h-[18px] w-[18px]"
                    style="padding: 6px 5px; position: relative; font-size: 12px; transform: rotate(90deg); top: 16px; border-radius: 100px"
                  >
                    <mat-icon style="font-size: 14px; position: relative; top: -3.5px; left: -3.5px" class="text-[#25508E]">clear</mat-icon>
                  </div> -->
                  <button (click)="$event.stopPropagation(); callAction(items)" class="m-2">View</button>
                  }
                </div>
              </div>
            </div>
            } }
          </div>
        </div>
        }@else{
        <div
          style="
            margin: 0px -24px;
            padding: 60px 0px;
            background: rgb(255, 255, 255);
            border: 1px solid rgba(177, 172, 176, 0.5);
            display: flex;
            align-items: center;
            flex-direction: column;
            border-radius: 5px;
          "
        >
          <img src="../../../../../../assets/images/setup-zero-state.svg" />
          <div class="mt-2" style="font-family: Open Sans; font-weight: 500; font-size: 14px; line-height: 24px; letter-spacing: 0%; color: #18191c">
            <span>No <span class="text-[#25508E] font-bold">Items</span> to show</span>
          </div>
        </div>
        }
      </mat-expansion-panel>
      <button
        class="add-ownership-button bg-[#FFFFFF] text-[#25508E]w-full"
        (click)="$event.stopPropagation(); markComplete()"
        mat-button
        [disableRipple]="true"
        style="width: 100%; border: 1.5px solid #25508e; margin: 10px 0; color: #25508e"
      >
        <span style="position: relative; font-weight: 600"> Mark all items complete </span>
      </button>
    </mat-accordion>
  </mat-dialog-content>
</div>
} }
